import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "mobile-sd"
};
const _hoisted_2 = {
  class: "text-line pt-6"
};
const _hoisted_3 = {
  class: "text-line"
};
const _hoisted_4 = {
  class: "running-job-list pt-3 pb-3"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "progress"
};
const _hoisted_7 = {
  key: 1,
  class: "task-in-queue"
};
const _hoisted_8 = {
  class: "finish-job-list"
};
const _hoisted_9 = {
  key: 0,
  class: "failed"
};
const _hoisted_10 = {
  class: "opt"
};
const _hoisted_11 = {
  key: 1,
  class: "job-item"
};
const _hoisted_12 = {
  class: "remove"
};
const _hoisted_13 = ["data-clipboard-text"];
import { onMounted, onUnmounted, ref } from "vue";
import { Delete } from "@element-plus/icons-vue";
import { httpGet, httpPost } from "@/utils/http";
import Clipboard from "clipboard";
import { checkSession, getClientId, getSystemInfo } from "@/store/cache";
import { useRouter } from "vue-router";
import { getSessionId } from "@/store/session";
import { showConfirmDialog, showDialog, showFailToast, showImagePreview, showNotify, showSuccessToast, showToast } from "vant";
import { showLoginDialog } from "@/utils/libs";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'ImageDall',
  setup(__props) {
    const listBoxHeight = ref(window.innerHeight - 40);
    const mjBoxHeight = ref(window.innerHeight - 150);
    const isLogin = ref(false);
    window.onresize = () => {
      listBoxHeight.value = window.innerHeight - 40;
      mjBoxHeight.value = window.innerHeight - 150;
    };
    const qualities = [{
      text: "标准",
      value: "standard"
    }, {
      text: "高清",
      value: "hd"
    }];
    const fluxSizes = [{
      text: "1024x1024",
      value: "1024x1024"
    }, {
      text: "1024x768",
      value: "1024x768"
    }, {
      text: "768x1024",
      value: "768x1024"
    }, {
      text: "1280x960",
      value: "1280x960"
    }, {
      text: "960x1280",
      value: "960x1280"
    }, {
      text: "1366x768",
      value: "1366x768"
    }, {
      text: "768x1366",
      value: "768x1366"
    }];
    const dalleSizes = [{
      text: "1024x1024",
      value: "1024x1024"
    }, {
      text: "1792x1024",
      value: "1792x1024"
    }, {
      text: "1024x1792",
      value: "1024x1792"
    }];
    let sizes = dalleSizes;
    const styles = [{
      text: "生动",
      value: "vivid"
    }, {
      text: "自然",
      value: "natural"
    }];
    const params = ref({
      client_id: getClientId(),
      quality: qualities[0].value,
      size: sizes[0].value,
      style: styles[0].value,
      prompt: ""
    });
    const quality = ref(qualities[0].text);
    const size = ref(sizes[0].text);
    const style = ref(styles[0].text);
    const showQualityPicker = ref(false);
    const showStylePicker = ref(false);
    const showSizePicker = ref(false);
    const showModelPicker = ref(false);
    const runningJobs = ref([]);
    const finishedJobs = ref([]);
    const router = useRouter();
    const power = ref(0);
    const dallPower = ref(0); // 画一张 DALL 图片消耗算力

    const userId = ref(0);
    const store = useSharedStore();
    const clipboard = ref(null);
    const prompt = ref("");
    const models = ref([]);
    const selectedModel = ref(null);
    onMounted(() => {
      initData();
      clipboard.value = new Clipboard(".copy-prompt-dall");
      clipboard.value.on("success", () => {
        showNotify({
          type: "success",
          message: "复制成功",
          duration: 1000
        });
      });
      clipboard.value.on("error", () => {
        showNotify({
          type: "danger",
          message: "复制失败",
          duration: 2000
        });
      });
      getSystemInfo().then(res => {
        dallPower.value = res.data.dall_power;
      }).catch(e => {
        showNotify({
          type: "danger",
          message: "获取系统配置失败：" + e.message
        });
      });
      store.addMessageHandler("dall", data => {
        if (data.channel !== "dall" || data.clientId !== getClientId()) {
          return;
        }
        if (data.body === "FINISH" || data.body === "FAIL") {
          page.value = 1;
          fetchFinishJobs(1);
        }
        fetchRunningJobs();
      });

      // 获取模型列表
      httpGet("/dall/models").then(res => {
        for (let i = 0; i < res.data.length; i++) {
          models.value.push({
            text: res.data[i].name,
            value: res.data[i].id,
            name: res.data[i].value
          });
        }
        selectedModel.value = models.value[0]?.text;
        params.value.model_id = models.value[0]?.value;
      }).catch(e => {
        showMessageError("获取模型列表失败：" + e.message);
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
      store.removeMessageHandler("dall");
    });
    const initData = () => {
      checkSession().then(user => {
        power.value = user["power"];
        isLogin.value = true;
        fetchRunningJobs();
        fetchFinishJobs(1);
      }).catch(() => {
        loading.value = false;
      });
    };
    const fetchRunningJobs = () => {
      // 获取运行中的任务
      httpGet(`/api/dall/jobs?finish=0`).then(res => {
        runningJobs.value = res.data.items;
      }).catch(e => {
        showNotify({
          type: "danger",
          message: "获取任务失败：" + e.message
        });
      });
    };
    const loading = ref(false);
    const finished = ref(false);
    const error = ref(false);
    const page = ref(0);
    const pageSize = ref(10);
    // 获取已完成的任务
    const fetchFinishJobs = page => {
      loading.value = true;
      httpGet(`/api/dall/jobs?finish=1&page=${page}&page_size=${pageSize.value}`).then(res => {
        const jobs = res.data.items;
        if (jobs.length < pageSize.value) {
          finished.value = true;
        }
        const _jobs = [];
        for (let i = 0; i < jobs.length; i++) {
          if (jobs[i].progress === -1) {
            jobs[i]["thumb_url"] = jobs[i]["img_url"] + "?imageView2/1/w/480/h/600/q/75";
          }
          _jobs.push(jobs[i]);
        }
        if (page === 1) {
          finishedJobs.value = _jobs;
        } else {
          finishedJobs.value = finishedJobs.value.concat(_jobs);
        }
        loading.value = false;
      }).catch(e => {
        loading.value = false;
        showNotify({
          type: "danger",
          message: "获取任务失败：" + e.message
        });
      });
    };
    const onLoad = () => {
      page.value += 1;
      fetchFinishJobs(page.value);
    };

    // 创建绘图任务
    const promptRef = ref(null);
    const generate = () => {
      if (!isLogin.value) {
        return showLoginDialog(router);
      }
      if (params.value.prompt === "") {
        promptRef.value.focus();
        return showToast("请输入绘画提示词！");
      }
      if (!params.value.seed) {
        params.value.seed = -1;
      }
      params.value.session_id = getSessionId();
      httpPost("/dall/image", params.value).then(() => {
        showSuccessToast("绘画任务推送成功，请耐心等待任务执行...");
        power.value -= dallPower.value;
        fetchRunningJobs();
      }).catch(e => {
        showFailToast("任务推送失败：" + e.message);
      });
    };
    const showPrompt = item => {
      prompt.value = item.prompt;
      showConfirmDialog({
        title: "绘画提示词",
        message: item.prompt,
        confirmButtonText: "复制",
        cancelButtonText: "关闭"
      }).then(() => {
        document.querySelector("#copy-btn-dall").click();
      }).catch(() => {});
    };
    const showErrMsg = item => {
      showDialog({
        title: "错误详情",
        message: item["err_msg"]
      }).then(() => {
        // on close
      });
    };
    const removeImage = (event, item) => {
      event.stopPropagation();
      showConfirmDialog({
        title: "标题",
        message: "此操作将会删除任务和图片，继续操作码?"
      }).then(() => {
        httpGet("/dall/remove", {
          id: item.id,
          user_id: item.user_id
        }).then(() => {
          showSuccessToast("任务删除成功");
          fetchFinishJobs(1);
        }).catch(e => {
          showFailToast("任务删除失败：" + e.message);
        });
      }).catch(() => {
        showToast("您取消了操作");
      });
    };

    // 发布图片到作品墙
    const publishImage = (event, item, action) => {
      event.stopPropagation();
      let text = "图片发布";
      if (action === false) {
        text = "取消发布";
      }
      httpGet("/dall/publish", {
        id: item.id,
        action: action,
        user_id: item.user_id
      }).then(() => {
        showSuccessToast(text + "成功");
        item.publish = action;
      }).catch(e => {
        showFailToast(text + "失败：" + e.message);
      });
    };
    const imageView = item => {
      showImagePreview([item["img_url"]]);
    };
    const qualityConfirm = item => {
      params.value.quality = item.selectedOptions[0].value;
      quality.value = item.selectedOptions[0].text;
      showQualityPicker.value = false;
    };
    const styleConfirm = item => {
      params.value.style = item.selectedOptions[0].value;
      style.value = item.selectedOptions[0].text;
      showStylePicker.value = false;
    };
    const sizeConfirm = item => {
      params.value.size = item.selectedOptions[0].value;
      size.value = item.selectedOptions[0].text;
      showSizePicker.value = false;
    };
    const modelConfirm = item => {
      params.value.model_id = item.selectedOptions[0].value;
      selectedModel.value = item.selectedOptions[0].text;
      showModelPicker.value = false;
      if (item.selectedOptions[0].name.startsWith("dall")) {
        sizes = dalleSizes;
      } else {
        sizes = fluxSizes;
      }
    };
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_circle = _resolveComponent("van-circle");
      const _component_van_grid_item = _resolveComponent("van-grid-item");
      const _component_van_grid = _resolveComponent("van-grid");
      const _component_van_loading = _resolveComponent("van-loading");
      const _component_el_button = _resolveComponent("el-button");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_form, {
        onSubmit: generate
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, {
          inset: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_van_field, {
            modelValue: selectedModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedModel.value = $event),
            "is-link": "",
            label: "生图模型",
            placeholder: "选择生图模型",
            onClick: _cache[1] || (_cache[1] = $event => showModelPicker.value = true)
          }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
            show: showModelPicker.value,
            "onUpdate:show": _cache[3] || (_cache[3] = $event => showModelPicker.value = $event),
            position: "bottom",
            teleport: "#app"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_picker, {
              columns: models.value,
              onCancel: _cache[2] || (_cache[2] = $event => showModelPicker.value = false),
              onConfirm: modelConfirm
            }, null, 8, ["columns"])]),
            _: 1
          }, 8, ["show"])]), _createElementVNode("div", null, [_createVNode(_component_van_field, {
            modelValue: quality.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => quality.value = $event),
            "is-link": "",
            label: "图片质量",
            placeholder: "选择图片质量",
            onClick: _cache[5] || (_cache[5] = $event => showQualityPicker.value = true)
          }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
            show: showQualityPicker.value,
            "onUpdate:show": _cache[7] || (_cache[7] = $event => showQualityPicker.value = $event),
            position: "bottom",
            teleport: "#app"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_picker, {
              columns: qualities,
              onCancel: _cache[6] || (_cache[6] = $event => showQualityPicker.value = false),
              onConfirm: qualityConfirm
            })]),
            _: 1
          }, 8, ["show"])]), _createElementVNode("div", null, [_createVNode(_component_van_field, {
            modelValue: size.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => size.value = $event),
            "is-link": "",
            label: "图片尺寸",
            placeholder: "选择图片尺寸",
            onClick: _cache[9] || (_cache[9] = $event => showSizePicker.value = true)
          }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
            show: showSizePicker.value,
            "onUpdate:show": _cache[11] || (_cache[11] = $event => showSizePicker.value = $event),
            position: "bottom",
            teleport: "#app"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_picker, {
              columns: _unref(sizes),
              onCancel: _cache[10] || (_cache[10] = $event => showSizePicker.value = false),
              onConfirm: sizeConfirm
            }, null, 8, ["columns"])]),
            _: 1
          }, 8, ["show"])]), _createElementVNode("div", null, [_createVNode(_component_van_field, {
            modelValue: style.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => style.value = $event),
            "is-link": "",
            label: "图片样式",
            placeholder: "选择图片样式",
            onClick: _cache[13] || (_cache[13] = $event => showStylePicker.value = true)
          }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
            show: showStylePicker.value,
            "onUpdate:show": _cache[15] || (_cache[15] = $event => showStylePicker.value = $event),
            position: "bottom",
            teleport: "#app"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_picker, {
              columns: styles,
              onCancel: _cache[14] || (_cache[14] = $event => showStylePicker.value = false),
              onConfirm: styleConfirm
            })]),
            _: 1
          }, 8, ["show"])]), _createVNode(_component_van_field, {
            modelValue: params.value.prompt,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => params.value.prompt = $event),
            rows: "3",
            autosize: "",
            type: "textarea",
            placeholder: "请在此输入绘画提示词，系统会自动翻译中文提示词，高手请直接输入英文提示词"
          }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_tag, null, {
            default: _withCtx(() => [_createTextVNode("绘图消耗" + _toDisplayString(dallPower.value) + "算力，当前算力：" + _toDisplayString(power.value), 1)]),
            _: 1
          })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode(" 立即生成 ")])),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }), _cache[27] || (_cache[27] = _createElementVNode("h3", null, "任务列表", -1)), _createElementVNode("div", _hoisted_4, [runningJobs.value.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        image: "https://fastly.jsdelivr.net/npm/@vant/assets/custom-empty-image.png",
        "image-size": "80",
        description: "暂无记录"
      })) : (_openBlock(), _createBlock(_component_van_grid, {
        key: 1,
        gutter: 10,
        "column-num": 3
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(runningJobs.value, item => {
          return _openBlock(), _createBlock(_component_van_grid_item, {
            key: item.id
          }, {
            default: _withCtx(() => [item.progress > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_image, {
              src: "/images/img-holder.png"
            }), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_circle, {
              "current-rate": item.progress,
              "onUpdate:currentRate": $event => item.progress = $event,
              rate: item.progress,
              speed: 100,
              text: item.progress + '%',
              "stroke-width": 60,
              size: "90px"
            }, null, 8, ["current-rate", "onUpdate:currentRate", "rate", "text"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[20] || (_cache[20] = [_createElementVNode("span", {
              class: "icon"
            }, [_createElementVNode("i", {
              class: "iconfont icon-quick-start"
            })], -1), _createElementVNode("span", {
              class: "text"
            }, "排队中", -1)])))]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }))]), _cache[28] || (_cache[28] = _createElementVNode("h3", null, "创作记录", -1)), _createElementVNode("div", _hoisted_8, [finishedJobs.value.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        image: "https://fastly.jsdelivr.net/npm/@vant/assets/custom-empty-image.png",
        "image-size": "80",
        description: "暂无记录"
      })) : (_openBlock(), _createBlock(_component_van_list, {
        key: 1,
        error: error.value,
        "onUpdate:error": _cache[17] || (_cache[17] = $event => error.value = $event),
        loading: loading.value,
        "onUpdate:loading": _cache[18] || (_cache[18] = $event => loading.value = $event),
        finished: finished.value,
        "error-text": "请求失败，点击重新加载",
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_createVNode(_component_van_grid, {
          gutter: 10,
          "column-num": 2
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finishedJobs.value, item => {
            return _openBlock(), _createBlock(_component_van_grid_item, {
              key: item.id
            }, {
              default: _withCtx(() => [item.progress === 101 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[23] || (_cache[23] = _createElementVNode("div", {
                class: "title"
              }, "任务失败", -1)), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_button, {
                size: "small",
                onClick: $event => showErrMsg(item)
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("详情")])),
                _: 2
              }, 1032, ["onClick"]), _createVNode(_component_van_button, {
                type: "danger",
                onClick: $event => removeImage($event, item),
                size: "small"
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("删除")])),
                _: 2
              }, 1032, ["onClick"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_van_image, {
                src: item['img_url'],
                class: _normalizeClass(item['can_opt'] ? '' : 'upscale'),
                "lazy-load": "",
                onClick: $event => imageView(item),
                fit: "cover"
              }, {
                loading: _withCtx(() => [_createVNode(_component_van_loading, {
                  type: "spinner",
                  size: "20"
                })]),
                _: 2
              }, 1032, ["src", "class", "onClick"]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
                type: "danger",
                icon: _unref(Delete),
                onClick: $event => removeImage($event, item),
                circle: ""
              }, null, 8, ["icon", "onClick"]), item.publish ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "warning",
                onClick: $event => publishImage($event, item, false),
                circle: ""
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [_createElementVNode("i", {
                  class: "iconfont icon-cancel-share"
                }, null, -1)])),
                _: 2
              }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "success",
                onClick: $event => publishImage($event, item, true),
                circle: ""
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [_createElementVNode("i", {
                  class: "iconfont icon-share-bold"
                }, null, -1)])),
                _: 2
              }, 1032, ["onClick"])), _createVNode(_component_el_button, {
                type: "primary",
                onClick: $event => showPrompt(item),
                circle: ""
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [_createElementVNode("i", {
                  class: "iconfont icon-prompt"
                }, null, -1)])),
                _: 2
              }, 1032, ["onClick"])])]))]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["error", "loading", "finished"]))]), _createElementVNode("button", {
        style: {
          "display": "none"
        },
        class: "copy-prompt-dall",
        "data-clipboard-text": prompt.value,
        id: "copy-btn-dall"
      }, "复制", 8, _hoisted_13)]);
    };
  }
};